module.exports = __webpack_public_path__ + "img/progress_031.ef643e5e.png";